import axiosInstance from './axiosInstance';

const addPrivateSubcategory = async ({ token, title, description, categoryId }) => {
  try {
    const response = await axiosInstance.post(
      '/privatesubcategories/add',
      { title, description, categoryId },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export { addPrivateSubcategory };
